import React, { Component, Fragment } from 'react';
import TextField from '@mui/material/TextField';
import withStyles from '@mui/styles/withStyles';
import moment from 'moment';
import { getElementValueWrapper, isNullOrUndefined, onChangeWrapper } from '../../utils/objects';
import { InputAdornment } from '@mui/material';
import { getValidationDecorations } from '../../utils/validation';
import { stringIsNullOrEmpty } from '../../utils/strings';
import Spinner from '../loading/Spinner';
import Button from './Button';
import { niceDateFromString, niceTimeFromString } from '../../utils/date';
import ReadonlyField from './ReadonlyField';

class FormTextField extends Component {
    state = {
        showButton: true
    };

    render() {
        let {
            classes,
            name,
            id,
            form,
            value,
            rows,
            title,
            InputProps = {},
            InputLabelProps,
            fullWidth,
            label,
            type,
            notFuture,
            notPast,
            validationResult,
            error,
            capitalize,
            onChange,
            onBlur,
            readOnly,
            icon,
            loading,
            emptyValue,
            button,
            autoFocus,
            ...other
        } = this.props;
        const { showButton } = this.state;

        if (notFuture) {
            InputProps.inputProps = { ...InputProps.inputProps, max: moment().format('YYYY-MM-DD') };
        }
        if (notPast) {
            InputProps.inputProps = { ...InputProps.inputProps, min: moment().format('YYYY-MM-DD') };
        }

        const baseClass = other.multiline ? 'input--multiline' : 'input';
        const decorations = getValidationDecorations(this.props);

        let formValue = getElementValueWrapper(this);
        if (type !== 'number' && !formValue) formValue = '';

        if (type === 'date') {
            InputLabelProps = { shrink: true };

            if (readOnly && formValue) {
                let dateValue = moment(formValue);

                if (dateValue.isValid()) {
                    formValue = niceDateFromString(dateValue);
                }
            }
        }

        if (type === 'time') {
            InputLabelProps = { shrink: true };
            formValue = ('' + formValue).replace(/.*?(\d\d:\d\d):00/, '$1');

            if (readOnly && formValue) {
                let timeValue = moment.utc(formValue, 'HH:mm');

                if (timeValue.isValid()) {
                    formValue = niceTimeFromString(timeValue);
                }
            }
        }

        if (decorations.inError === true) {
            InputLabelProps ? (InputLabelProps.shrink = true) : (InputLabelProps = { shrink: true });
        }

        if (readOnly) {
            return <ReadonlyField label={label} validationClass={decorations.cssClass}>{formValue}</ReadonlyField>;
        }

        if (!isNullOrUndefined(button)) {
            if (!!showButton && stringIsNullOrEmpty(formValue)) {
                return this.renderButton();
            }
        }

        let startAdornment;
        if (!isNullOrUndefined(icon)) {
            startAdornment = <InputAdornment position="start">{loading ? <Spinner size="xs" /> : icon}</InputAdornment>;
        }

        return (
            <span className="textfield input">
                <TextField
                    FormHelperTextProps={{
                        error: decorations.inError === true,
                        classes: {
                            error: `validation-label ${decorations.cssClass}`
                        }
                    }}
                    readOnly={readOnly}
                    helperText={decorations.errorMsg}
                    title={title}
                    id={id || (name ? `text-${name}` : undefined)}
                    name={name}
                    rows={other.multiline ? (rows ? rows : 4) : null}
                    value={formValue}
                    onChange={e => onChangeWrapper(e, this, false, 'number' === type)}
                    onBlur={e => {
                        e.persist(); // sends after state change
                        this.setState({ showButton: true }, () => onBlur && onBlur(e));
                    }}
                    fullWidth={fullWidth}
                    label={
                        stringIsNullOrEmpty(label)
                            ? undefined
                            : (
                                <Fragment>
                                    {decorations.validationIcon}
                                    <span className="label-text">{label}</span>
                                </Fragment>
                            )
                    }
                    type={type}
                    InputProps={{
                        disableUnderline: true,
                        classes: {
                            root: `${baseClass} ${decorations.cssClass}`,
                            focused: 'input--focused'
                        },
                        startAdornment,
                        ...InputProps
                    }}
                    InputLabelProps={{
                        className: 'label',
                        classes: {
                            shrink: `label--shrink ${decorations.cssClass}`
                        },
                        ...InputLabelProps
                    }}
                    autoFocus={!!button && !showButton ? true : autoFocus}
                    {...other}
                />
            </span>
        );
    }

    renderButton() {
        const { button } = this.props;
        return <Button variant="secondary" {...button} onClick={() => this.setState({ showButton: false })} />;
    }
}

FormTextField.defaultProps = {
    fullWidth: false,
    emptyValue: ''
};

export default withStyles({})(FormTextField);
